import React, { useContext, useState } from "react";
import { BsBuildings } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import BackTool from "../../components/Toolnav/BackTool";
import { useQuery } from "@tanstack/react-query";
import { handleFetchCompany } from "../../api/company";
import { useParams } from "react-router";
import Something from "../../components/Shared/Something";
import AddCoUser from "./components/AddCoUser";
import { handleFetchCompanyUser } from "../../api/user";
import { AuthContext } from "../../contexts/AuthContext";
import { FiEdit } from "react-icons/fi";
import { CgMoveTask } from "react-icons/cg";
import UpdateUser from "./components/UpdateUser";
import MigrateUser from "./components/MigrateUser";
import { RiDeleteBin6Line } from "react-icons/ri";
import DeleteUser from "./components/DeleteUser";

export default function OneMember() {
  const { auth } = useContext(AuthContext);
  const access = ["Admin", "Manager", "Instructor"];
  const editAccess = [7];
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [migrateModal, setMigrateModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});
  const { id } = useParams();

  const {
    data: member,
    isError,
    isFetching,
  } = useQuery({
    queryKey: ["companies", id],
    queryFn: () => handleFetchCompany({ _id: id }),
  });

  const { data: users, refetch } = useQuery({
    queryKey: ["users", id],
    queryFn: () => handleFetchCompanyUser({ _id: id }),
  });

  return (
    <div>
      <BackTool menus={[{ id: 1, name: "Member", to: "/members" }]} />
      {isError ? (
        <Something refetch={refetch} isFetching={isFetching} />
      ) : (
        <div className="p-2">
          <div className="border bg-white">
            <div className=" border-b mb-1 bg-white flex text-sm cursor-pointer">
              <div className="flex justify-between items-center p-2 w-full">
                <div className="flex items-center">
                  <div className="h-20 w-20 rounded-md bg-gray-200 flex justify-center items-center">
                    <BsBuildings size={35} />
                  </div>
                  <div className="flex flex-col ml-4">
                    <div className="font-bold text-lg uppercase">
                      {member?.name}
                    </div>
                    <div className="text-gray-600">Email: {member?.email}</div>
                    <div className="text-gray-600">
                      Mobile: {member?.mobile}
                    </div>
                    <div className="text-gray-600 capitalize font-bold">
                      {member?.segment}
                    </div>
                  </div>
                </div>
                {access?.includes(auth?.role) && (
                  <div className="">
                    {auth?.company?.name === member?.name ||
                    auth?.role === "Admin" ? (
                      <button
                        onClick={() => setCreateModal(true)}
                        className="flex justify-center items-center text-xs border p-1"
                      >
                        <span className="mr-2">
                          <AiOutlinePlus />
                        </span>
                        Add Member
                      </button>
                    ) : null}
                  </div>
                )}
              </div>
            </div>

            <div className="">
              <div className="p-2">
                <div className="pb-2">Members</div>
                <div className="mb-8">
                  <div className="border-t border-r border-l border-b-4 flex justify-between items-center">
                    <div className="flex">
                      <div className="w-12 p-2 border-r">S/N</div>
                      <div className="w-72 p-2 border-r">NAME</div>
                      <div className="w-72 p-2 border-r">EMAIL</div>
                      <div className="w-72 p-2">ROLE</div>
                      <div className="w-72 p-2">ACCESS</div>
                    </div>
                    <div className="w-72  border-l flex item-center justify-between">
                      <div className="p-2">MOBILE</div>
                      {editAccess.includes(auth?.accessLevel) && (
                        <div className="border-l p-2 w-32 text-center">
                          ACTION
                        </div>
                      )}
                    </div>
                  </div>
                  {users?.payload?.map((item: any, index: number) => (
                    <div
                      className="flex justify-between border text-gray-600 text-sm"
                      key={index}
                    >
                      <div className="flex">
                        <div className="w-12 border-r p-2 text-center">
                          {index + 1}
                        </div>
                        <div className="w-72 border-r p-2">{item?.name}</div>
                        <div className="w-72 border-r  p-2">{item?.email}</div>
                        <div className="w-72 p-2 capitalize">{item?.role}</div>
                        <div className="w-72 p-2 capitalize">
                          Level {item?.accessLevel}
                        </div>
                      </div>
                      <div className="w-72 border-l flex items-center justify-between">
                        <div className="p-2">{item?.mobile}</div>
                        {editAccess.includes(auth?.accessLevel) && (
                          <div className="flex items-center justify-end w-32 p-2 border-l">
                            <button
                              className="mx-3 hover:text-toyota cursor-pointer"
                              onClick={() => {
                                setSelected(item);
                                setUpdateModal(true);
                              }}
                            >
                              <FiEdit size={17} />
                            </button>
                            {item?.accessLevel === 7 ? (
                              <button
                                className="mx-3 hover:text-toyota cursor-pointer"
                                disabled
                              >
                                <RiDeleteBin6Line color="#FAD9D9" size={17} />
                              </button>
                            ) : (
                              <button
                                className="mx-3 hover:text-toyota cursor-pointer"
                                onClick={() => {
                                  setSelected(item);
                                  setDeleteModal(true);
                                }}
                              >
                                <RiDeleteBin6Line size={17} />
                              </button>
                            )}
                            <button
                              className="hover:text-toyota cursor-pointer"
                              onClick={() => {
                                setSelected(item);
                                setMigrateModal(true);
                              }}
                            >
                              <CgMoveTask size={28} />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <AddCoUser
            isVisible={createModal}
            setVisible={setCreateModal}
            company={member}
            refetch={refetch}
            company_id={id}
          />

          <UpdateUser
            isVisible={updateModal}
            setVisible={setUpdateModal}
            company={member}
            user={selected}
            refetch={refetch}
            company_id={id}
          />

          <MigrateUser
            isVisible={migrateModal}
            setVisible={setMigrateModal}
            company={member}
            user={selected}
            refetch={refetch}
            company_id={id}
          />
          <DeleteUser
            isVisible={deleteModal}
            setVisible={setDeleteModal}
            refetch={refetch}
            user={selected}
            company_id={id}
          />
        </div>
      )}
    </div>
  );
}
